import { type IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faBuilding, faHouse } from '@fortawesome/pro-solid-svg-icons'

import { UserTypeEnum } from '../generated/graphql'

export type UserType = {
  name: string
  icon: IconDefinition
}

export { UserTypeEnum }

export const USERS: Record<UserTypeEnum, UserType> = {
  [UserTypeEnum.Particulier]: {
    name: 'Particulier',
    icon: faHouse,
  },
  [UserTypeEnum.Professionnel]: {
    name: 'Professionnel',
    icon: faBuilding,
  },
  [UserTypeEnum.Collectivite]: {
    name: 'Collectivité',
    icon: faBuilding,
  },
}
